import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-rent-home',
    templateUrl: './rent-home.component.html',
    styleUrls: ['./rent-home.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentHomeComponent {

}
